var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.084 2.293c-2.384 0-4.375 1.99-4.375 4.375v1.458H5.417a.21.21 0 0 0-.208.209v3.333c0 .115.093.208.208.208H7.71v5.625c0 .115.093.209.208.209h3.334a.21.21 0 0 0 .208-.209v-5.625h2.292a.21.21 0 0 0 .201-.158l.834-3.333a.21.21 0 0 0-.038-.179.2.2 0 0 0-.164-.08h-3.125V6.668a.633.633 0 0 1 .625-.625h2.5a.21.21 0 0 0 .208-.208V2.5a.21.21 0 0 0-.208-.208z"
  })));
};
export default SvgFacebook;